<template>
  <div class="products">
    <section class="page-header text-white py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h1 class="page-title">{{ $t('products.title') }}</h1>
            <p class="page-subtitle">{{ $t('products.subtitle') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 行业分类导航 -->
    <section class="category-nav py-3 sticky-nav">
      <div class="container text-center">
        <a v-for="cat in categories" :key="cat.id" :href="'#' + cat.id"
           class="cat-link btn btn-sm m-1" @click.prevent="scrollTo(cat.id)">
          {{ cat.name }}
        </a>
      </div>
    </section>

    <!-- 各行业产品 -->
    <section class="product-list py-5">
      <div class="container">
        <div v-for="cat in categories" :key="cat.id" :id="cat.id" class="category-block mb-5">
          <div class="category-head mb-4">
            <h2 class="section-title mb-1">{{ cat.name }}</h2>
            <p class="section-subtitle text-muted mb-0">{{ cat.subtitle }}</p>
          </div>
          <div class="row g-4">
            <div class="col-lg-4 col-md-6 mb-4 wow animate__fadeInUp" :data-wow-delay="(index % 3 * 0.1) + 's'" v-for="(p, index) in itemsOf(cat.id)" :key="p.slug">
              <router-link :to="'/products/' + p.slug" class="product-card-link">
                <div class="product-card bg-white rounded shadow-sm overflow-hidden h-100">
                  <div class="product-img">
                    <img :src="p.hero" :alt="p.name">
                  </div>
                  <div class="p-4">
                    <h5 class="mb-2">{{ p.name }}</h5>
                    <p class="text-muted small mb-3">{{ p.tagline }}</p>
                    <span class="detail-link">{{ $t('products.viewDetail') }} <i class="fas fa-arrow-right ml-1"></i></span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import { getCategories, getProductsByCategory } from '@/data/catalog'

export default {
  name: 'Products',
  computed: {
    categories() {
      return getCategories()
    }
  },
  mounted() {
    try {
      new WOW({ boxClass: 'wow', animateClass: 'animate__animated', offset: 60, mobile: true, live: false }).init()
    } catch (e) { /* noop */ }
  },
  methods: {
    itemsOf(catId) {
      return getProductsByCategory(catId)
    },
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 80
        window.scrollTo({ top: y, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.page-header { background: linear-gradient(135deg, #002850 0%, #0a4d8c 100%); }
.page-title { font-size: 2.5rem; font-weight: bold; }
.page-subtitle { font-size: 1.1rem; opacity: 0.9; }

.sticky-nav {
  position: sticky;
  top: 0;
  z-index: 900;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.cat-link {
  border: 1px solid #cfe0f5;
  color: #0a4d8c;
  background: #fff;
  font-weight: 500;
}
.cat-link:hover { background: #007bff; color: #fff; border-color: #007bff; }

.category-head { border-left: 4px solid #007bff; padding-left: 0.85rem; }
.section-title { font-weight: 700; }

.product-card-link { display: block; color: inherit; text-decoration: none; }
.product-card-link:hover { text-decoration: none; color: inherit; }
.product-card { transition: all 0.3s ease; }
.product-img {
  height: 200px;
  overflow: hidden;
  background: linear-gradient(135deg, #0a4d8c 0%, #06325c 100%);
}
.product-img img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease; }
.product-card-link:hover .product-card {
  transform: translateY(-8px);
  box-shadow: 0 14px 34px rgba(0, 40, 80, 0.16) !important;
}
.product-card-link:hover .product-img img { transform: scale(1.06); }
.detail-link { color: #007bff; font-weight: 600; font-size: 0.9rem; }

@media (max-width: 768px) {
  .page-title { font-size: 2rem; }
}
</style>
